import React, { useEffect, useState } from "react";
import { CartState } from "../context/Context";
import { Button, Col, Form, Image, ListGroup, Row } from "react-bootstrap";
import Rating from "./Rating";
import { AiFillDelete } from "react-icons/ai";
import image from "../Images/peter-broomfield-m3m-lnR90uM-unsplash.jpg";

const Cart = () => {
  const {
    state: { cart },
    dispatch,
  } = CartState();

  const [total, setTotal] = useState();
  useEffect(() => {
    setTotal(cart.reduce((acc, curr) => +curr.price * curr.qty + acc, 0));
  }, [cart]);
  return (
    <div className="home">
      <div className="productContainer">
        <ListGroup>
          {cart.map((prod) => (
            <ListGroup.Item key={prod.id}>
              <Row>
                <Col md={2}>
                  <Image src={image} alt={prod.name} fluid rounded />
                </Col>
                <Col md={2}>
                  <span>{prod.name}</span>
                </Col>

                <Col md={2}>
                  <span>$ {prod.price}</span>
                </Col>

                <Col md={2}>
                  <span>
                    <Rating rating={prod.ratings} onClick={() => {}} />
                  </span>
                </Col>
                <Col md={2}>
                  <Form.Control
                    style={{ cursor: "pointer" }}
                    as="select"
                    value={prod.qty}
                    onChange={(e) => {
                      return dispatch({
                        type: "CHANGE_CART_QTY",
                        id: prod.id,
                        qty: e.target.value,
                      });
                    }}
                  >
                    {[...Array(prod.inStock).keys()].map((x) => {
                      return <option key={x + 1}>{x + 1}</option>;
                    })}
                  </Form.Control>
                </Col>
                <Col md={2}>
                  <Button
                    type="button"
                    variant="light"
                    onClick={() => {
                      return dispatch({
                        type: "REMOVE_FROM_CART",
                        payload: prod,
                      });
                    }}
                  >
                    <AiFillDelete fontSize="20px" />
                  </Button>
                </Col>
              </Row>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </div>
      <div className="filters summary">
        <span className="title">Subtotal ({cart.length}) items</span>
        <span style={{ fontWeight: 700, fontSize: 20 }}> Total: $ {total}</span>
        <Button type="button" disabled={cart.length === 0}>
          Proceed to Checkout
        </Button>
      </div>
    </div>
  );
};

export default Cart;
